import { render, staticRenderFns } from "./DevInfoDetail.vue?vue&type=template&id=290d6bdb&scoped=true"
import script from "./DevInfoDetail.vue?vue&type=script&lang=js"
export * from "./DevInfoDetail.vue?vue&type=script&lang=js"
import style0 from "./DevInfoDetail.vue?vue&type=style&index=0&id=290d6bdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290d6bdb",
  null
  
)

export default component.exports